import { DEFAULT_FETEBUDDY_PROMPT_KEYS } from "constants/llm"
import { DEFAULT_LLM_MODEL_CONFIG } from "utils/constant"
import { getFormattedHistory, getFullDateAndTimeFormatted } from "utils/llm"

export enum VectorStoreTypes {
    MONGODB = 'mongodb',
    PINECONE = 'pinecone',
    ELASTICSEARCH = 'elasticsearch'
}

export interface LLMAgentInstructPayload {
    model_platform?: string,
    model_temperature?: number,
    prompt_key?: string,
    model_name?: string,
    input_variables: object
}

export interface LLMAgentConversationRetrivalPayload {
    model_platform?: string,
    model_temperature?: number,
    prompt_key?: string,
    model_name?: string,
    input_variables?: object,
    session_id: string,
    metadata_filter?: object
}

export interface LLMAgentRAGCreatePayload {
    model_platform?: string,
    file_path?: string,
    vector_store_type?: VectorStoreTypes,
    metadata?: object,
    // text_content?: string,
    session_id?: string
}

export interface LLMAgentImageCreatePayload {
    prompt: string,
    model?: string,
    n?: number,
    size?: string
}

export interface LLMAgentRAGUpdatePayload {
    model_platform?: string,
    model_temperature?: number,
    model_name?: string,
    document_path?: string,
    vector_store_type?: VectorStoreTypes,
    session_id: string,
    additional_metadata?: object,
    text_content?: string,
    text_prefix?: string,
}

export interface LLMAgentRAGDeletePayload {
    index_name?: string,
    document_id?: number
}

export const getLLMAgentInstructPayload = ({
    input_variables, model_platform = DEFAULT_LLM_MODEL_CONFIG.CHAT_PROVIDER, model_temperature = 0, prompt_key = "FETEBOARD_EXTRACT_FETE_OVERVIEW", model_name = DEFAULT_LLM_MODEL_CONFIG.INSTRUCT_MODEL
}: LLMAgentInstructPayload ): LLMAgentInstructPayload => {
    return {
        "model_platform": model_platform,
        "model_temperature": model_temperature,
        "prompt_key": prompt_key,
        "model_name": model_name,
        "input_variables": input_variables,
    }
}

export const getLLMAgentConversationRetrivalPayload = ({
    session_id, 
    metadata_filter, 
    input_variables, 
    prompt_key = DEFAULT_FETEBUDDY_PROMPT_KEYS.START, 
    model_name = DEFAULT_LLM_MODEL_CONFIG.CHAT_MODEL, 
    model_platform = DEFAULT_LLM_MODEL_CONFIG.CHAT_PROVIDER, 
    model_temperature = 0
}: LLMAgentConversationRetrivalPayload ): LLMAgentConversationRetrivalPayload => {
    return {
        "model_platform": model_platform,
        "model_temperature": model_temperature,
        "prompt_key": prompt_key,
        "model_name": model_name,
        "input_variables": input_variables,
        "session_id": session_id,
        "metadata_filter": metadata_filter
    }
}

export const getLLMAgentRAGCreatePayload = ({
    metadata, 
    file_path = '',  
    vector_store_type = VectorStoreTypes.PINECONE ,
    model_platform = DEFAULT_LLM_MODEL_CONFIG.CHAT_PROVIDER,
    // text_content = '',
    session_id
}: LLMAgentRAGCreatePayload): LLMAgentRAGCreatePayload => {
    return {
        "model_platform": model_platform,
        "file_path": file_path,
        "vector_store_type": vector_store_type,
        "metadata": metadata,
        // "text_content": text_content,
        "session_id": session_id
    }
}

export const getLLMAgentCreateImagePayload = ({
    prompt, model = DEFAULT_LLM_MODEL_CONFIG.IMAGE_MODEL, n = 1, size = '1024x1024'
}: LLMAgentImageCreatePayload ): LLMAgentImageCreatePayload => {
    return {
        prompt: prompt,
        model: model,
        n: n,
        size: size
    }
}

export const getLLMAgentRAGUpdatePayload = ({
    session_id, 
    additional_metadata, 
    document_path = '', 
    text_content = '', 
    text_prefix = '',
    vector_store_type = VectorStoreTypes.PINECONE ,
    model_platform = DEFAULT_LLM_MODEL_CONFIG.CHAT_PROVIDER, 
    model_temperature = 0, 
    model_name = DEFAULT_LLM_MODEL_CONFIG.CHAT_MODEL
}: LLMAgentRAGUpdatePayload): LLMAgentRAGUpdatePayload => {
    return {
        "model_platform": model_platform,
        "model_temperature": model_temperature,
        "model_name": model_name,
        "document_path": document_path,
        "vector_store_type": vector_store_type,
        "session_id": session_id,
        "additional_metadata": additional_metadata,
        "text_content": text_content,
        "text_prefix": text_prefix
    }
}

export const getLLMAgentRAGDeletePayload = ({
    index_name = 'feteboard', 
    document_id,
}: LLMAgentRAGDeletePayload): LLMAgentRAGDeletePayload => {
    return {
        "index_name": index_name,
        "document_id": document_id
    }
}